import type { Reference, Side } from '@ps/web-martech-cms-types';
import { ContentType } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSReference } from '@swf/cms';

import styles from './CMSSide.scss';

const CMSSide: React.FC<Side> = ({ body }) => (
  <>
    {body.map((item) => {
      const [sideContent] = Object.values(item);
      return sideContent.reference.map((ref: Reference, idx: number) => (
        <React.Fragment key={idx}>
          {ref._content_type_uid === ContentType.SideRelatedContent && (
            <div className={styles.separator} />
          )}
          <CMSReference {...ref} />
        </React.Fragment>
      ));
    })}
  </>
);

export default CMSSide;
